import * as dataNormalizers from "./dataNormalizers";
import * as listHeads from "./listHeads";
import * as filterBuilders from "./filterBuilders";

const formModules = import.meta.glob(["./Immigration.jsx", "./Taxes.jsx", "./Crime.jsx", "./Injury.jsx", "./Family.jsx"], { eager: true });

export const forms = ["Immigration", "Taxes", "Crime", "Injury", "Family"];

export function getForm(formName) {
    const mod = formModules[`./${formName}.jsx`];
    return mod?.default;
}

export function getDataNormalizer(formName) {
    return dataNormalizers[formName] || ((d) => d);
}

export function getListHead(formName) {
    return listHeads[formName];
}

export function getFiltersBuilder(formName) {
    return filterBuilders[formName];
}
